// extracted by mini-css-extract-plugin
export var item = "NavigationList-module--item--7d651";
export var list = "NavigationList-module--list--6dfcc";
export var mobile = "NavigationList-module--mobile--5f433";